import React, { ReactNode } from 'react';
import {
  CommerceAddress,
  Maybe,
  SoldToAddress,
  TasstaxIdLabel,
  TaxId as TaxIdType,
} from '@css-xp/graphtypes/src/generated-types-new';
// @ts-ignore
import TaxExemptIcon from '@css-xp/base/assets/img/icon-tax-exempt.svg';
import ToolTip from '@atlaskit/tooltip';
import './tax-component.scss';
import { NoData } from '@css-xp/ppc-common';

export interface TaxComponentProps {
  billToAddress: CommerceAddress | undefined | null;
  gridItemClassName?: string;
  hasSeparator?: boolean;
}

export type TaxIdDetail = {
  label: string | null | undefined;
  value: string | ReactNode;
};

const TaxExempt = () => {
  return (
    <div className="tax-exempt-icon">
      <ToolTip content={'Tax exempted'} tag="span" position="mouse">
        {/*// @ts-ignore */}
        <img src={TaxExemptIcon} height={'16px'} alt="Tax exempted" />
      </ToolTip>
    </div>
  );
};

function taxLabelComparator() {
  return (a: Maybe<TaxIdType>, b: Maybe<TaxIdType>) => {
    const taxLabelA = a?.label || '';
    const taxLabelB = b?.label || '';
    if (taxLabelA < taxLabelB) {
      return -1;
    }
    if (taxLabelA > taxLabelB) {
      return 1;
    }
    return 0;
  };
}

export const getTaxIdLabels = (
  billToAddress: CommerceAddress | SoldToAddress | null | undefined,
  shouldHideTaxExemptIcon = false
) => {
  if (billToAddress?.taxIds && billToAddress?.taxIds?.length > 0) {
    const billToTaxIds = [...billToAddress.taxIds];
    billToTaxIds.sort(taxLabelComparator());

    let taxIdLabels: TasstaxIdLabel[] | undefined;
    const taxLabels = billToAddress?.taxLabels;
    if (taxLabels && taxLabels.length > 0) {
      taxIdLabels = taxLabels[0]?.taxIdLabels as TasstaxIdLabel[];
    }

    return billToTaxIds?.map((taxId) => {
      const taxIdLabel = taxIdLabels?.filter(({ type }) => type && type === taxId?.label);
      const displayTaxLabel = taxIdLabel?.[0]?.displayName ?? '';
      return {
        label: `${displayTaxLabel} Tax ID`,
        value: (
          <div data-testid={`multi-tax-id-${taxId?.id}`} className="tax-content">
            <span>{taxId?.id}</span>
            {!shouldHideTaxExemptIcon && taxId?.taxExempt && <TaxExempt />}
          </div>
        ),
      };
    });
  }

  return [
    {
      label: 'Tax ID',
      value: (
        <div className="tax-content" data-testid="tax-id">
          {billToAddress?.taxId ?? <NoData testId="no-tax-id-available" />}
        </div>
      ),
    },
  ];
};

export const TaxComponent = ({ billToAddress, gridItemClassName = '', hasSeparator }: TaxComponentProps) => {
  const billToTaxIds = billToAddress ? getTaxIdLabels(billToAddress) : [];
  return (
    <>
      {billToTaxIds?.map((taxId, index) => (
        <div className={gridItemClassName} key={`tax-id-${index}`}>
          <label>
            {taxId?.label}
            {hasSeparator && ' : '}
          </label>
          {taxId?.value}
        </div>
      ))}
    </>
  );
};
